import { isAxiosError } from "axios";
import type { Dispatch } from "@reduxjs/toolkit";
import { displayAlert } from "../slice/alertSlice.tsx";

// 429s are shown by the global axios interceptor — skip here to avoid duplicate toasts.
// Returns the resolved message so callers can pass it to rejectWithValue.
export const handleThunkError = (
  e: unknown,
  dispatch: Dispatch,
  fallback = "An unexpected error occurred.",
): string => {
  if (isAxiosError(e) && e.response?.status === 429) return fallback;
  const detail =
    isAxiosError(e) && (e.response?.data as { detail?: string })?.detail;
  const message = detail || fallback;
  dispatch(displayAlert({ type: "error", text: message }));
  return message;
};
